import axios from 'axios';

export default {
    name: 'reset-password',
    // Initial props provided by Login.vue.
    props: ['code', 'token', 'user'],
    // Initial data.
    data() {
        return {
            password: '',
            rules: [
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_MIN_CHAR'),
                    regex: /.{9,}/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_ONE_UPPERCASE'),
                    regex: /[A-Z]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_ONE_LOWERCASE'),
                    regex: /[a-z]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_ONE_NUMBER'),
                    regex: /[0-9]+/
                },
                {
                    show: true,
                    icon: 'check',
                    color: 'gray-10',
                    specialCharacters: false,
                    message: this.$t('HC_AT_LEAST_ONE_SPECIAL_CHARACTER'),
                    regex: /[!#$%&?@_~<=>*-]+/
                },
                {
                    show: false,
                    icon: 'times',
                    color: 'red-30',
                    specialCharacters: true,
                    message:
                        this.$t('HC_SPECIAL_CHARACTER') +
                        '! # $ % & * - < = > ? @ _ ~',
                    regex: /^[A-Za-z0-9!#$%&?@_~<=>*-]+$/
                }
            ],
            passwordConfirm: '',
            showConfirmHint: false,
            buttonClasses: ['is-fullwidth'],
            passwordType: 'password',
            passwordConfirmType: 'password',
            loadingState: false
        };
    },
    computed: {
        showValidationMessages() {
            return this.passwordValidation.passwordRules.filter(function(rule) {
                return rule.show;
            });
        },
        passwordValidation() {
            let passwordRules = this.rules;
            let valid = true;
            let isInputEmpty = this.password.length <= 0;

            for (let condition of passwordRules) {
                // If rule is special character validation rule
                if (condition.specialCharacters) {
                    // If entered allowed spectial characters
                    if (!condition.regex.test(this.password)) {
                        if (isInputEmpty) {
                            condition.show = false;
                        } else {
                            condition.show = true;
                        }
                        condition.color = 'red-30';
                        valid = false;
                    } else {
                        condition.show = false;
                        condition.color = 'gray-10';
                    }
                }
                // The rest of the validation rules
                else {
                    if (!condition.regex.test(this.password)) {
                        condition.color = 'gray-10';
                        valid = false;
                    } else {
                        condition.color = 'quore-green';
                    }
                }
            }
            return {
                valid: valid,
                passwordRules
            };
        },
        samePasswords() {
            return (
                this.password === this.passwordConfirm &&
                this.password &&
                this.passwordConfirm
            );
        },
        validPassword() {
            return this.samePasswords && this.passwordValidation.valid;
        }
    },
    // Methods needed for this component.
    methods: {
        onConfirmFocus() {
            this.showConfirmHint = true;
        },
        // Handle the submission of the reset password form.
        onSubmit() {
            // Add the loading spinner icon to the button.
            this.loadingState = true;

            this.$emit('currentAlert', null);

            let data = {
                username: this.user.username,
                password: this.password
            };
            // Reset password
            axios
                .post(
                    `${process.env.VUE_APP_QV4_API}/users/reset-password`,
                    data,
                    {
                        headers: {
                            'x-api-key': this.token
                        }
                    }
                )
                // Handle success
                .then(() => {
                    // Set success alert data.
                    let alert = {
                        message: this.$t('HC_SUCCESS_UPDATED_ACCOUNT'),
                        status: '',
                        icon: 'check-circle-outline'
                    };
                    // If it's successfully updated, transition to LoginForm component and alert user.
                    this.$emit('currentAlert', alert);
                    this.$emit('currentView', 'login-form');
                    this.$emit(
                        'currentTransition',
                        'component-slide-fade-left'
                    );
                })
                // If the API request fails due to connectivity or any other reason.
                .catch((error) => {
                    // Remove loading spinner on button
                    this.loadingState = false;

                    let alertMessage = this.$t('HC_OOPS_SOMETHING_WENT_WRONG');
                    
                    // Check if the error message contains the specific password reuse message
                    if (error.response && error.response.data && error.response.data.error) {
                        const errorMessage = error.response.data.error;
                        if (errorMessage.includes('Password cannot be the same as any of your previous 4 passwords')) {
                            alertMessage = this.$t('HC_PASSWORD_CANNOT_BE_THE_SAME');
                        }
                    }

                    // Set error alert data.
                    let alert = {
                        message: alertMessage,
                        status: 'danger',
                        icon: 'exclamation-circle-outline'
                    };
                    // Send alert data to parent component.
                    this.$emit('currentAlert', alert);
                });
        }
    }
};
